import { render, staticRenderFns } from "./WhitelabelTest.vue?vue&type=template&id=996a0b4c&scoped=true"
import script from "./WhitelabelTest.vue?vue&type=script&lang=js"
export * from "./WhitelabelTest.vue?vue&type=script&lang=js"
import style0 from "./WhitelabelTest.vue?vue&type=style&index=0&id=996a0b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a0b4c",
  null
  
)

export default component.exports